module.exports = __webpack_public_path__ + "static/img/bg-20261029.2268042.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/bg-20261029.png
// module id = 4IEz
// module chunks = 23